<template>
  <v-container>
    <h1>{{ $store.getters.dictionaryName }} / Sections</h1>
    <TranslatedSectionsTable v-on:edit="edit($event)"></TranslatedSectionsTable>
    <TranslatedSectionDialog v-model="dialog" :model="model"></TranslatedSectionDialog>
  </v-container>
</template>

<script>
import TranslatedSectionsTable from '../components/TranslatedSectionsTable'
import TranslatedSectionDialog from '../components/TranslatedSectionDialog'

export default {
  components: { TranslatedSectionDialog, TranslatedSectionsTable },
  data () {
    return {
      model: null,
      dialog: false
    }
  },
  methods: {
    edit (model) {
      this.model = model
      this.dialog = true
    }
  }
}
</script>
